import ErrorMessage from '@components/ErrorMessage'
import { vehiclesSelector } from 'dashboard-vehicles/selectors'
import { removeVehicle } from 'dashboard-vehicles/actions'
import ListItem from 'dashboard-vehicles/components/ListItem'
import { pendingSelector } from 'api/selectors'
import { useConfirm } from 'shared/hooks/useConfirm'

const VehicleList = ({ vehicles = [], pending, removeVehicle }) => {
    const { confirm, ConfirmModal } = useConfirm()

    const error = pending.removeVehicle && pending.removeVehicle instanceof Error && pending.removeVehicle.message

    const onRemove = async vehicle => {
        const isConfirmed = await confirm()
        if (isConfirmed) {
            removeVehicle(vehicle)
        }
    }

    return (
        <>
            <ConfirmModal title="dashboard.vehicles.warning.title" text="dashboard.vehicles.warning.text" />
            <ul className="vehicles-list list-with-buttons">
                {vehicles.map(vehicle => (
                    <ListItem
                        {...vehicle}
                        onDelete={() => onRemove(vehicle)}
                        key={vehicle.id}
                        pending={pending[`removeVehicle-${vehicle.id}`] === true}
                    />
                ))}
                {error && <ErrorMessage className="vehicle-error" messages={[error]} />}
            </ul>
        </>
    )
}
const mapStateToProps = createStructuredSelector({
    vehicles: vehiclesSelector,
    pending: pendingSelector,
})

const mapDispatchToProps = {
    removeVehicle,
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleList)
